<template>
  <div>
    <Header />
    <v-carousel cycle>
      <v-carousel-item class="tw-min-h-100">
        <div
          class="slide3 tw-flex tw-content-center tw-justify-end  tw-text-white tw-p-8"
        >
          <div class="tw-my-auto tw-px-4">
            <h1
              class="tw-text-right tw-text-3xl tw-font-semibold md:tw-text-4xl"
            >
              CARBON <span class="tw-text-blue-700">REDUCTION</span> FOR
              EVERYONE
            </h1>
            <h1
              class="tw-text-right tw-text-2xl tw-font-semibold md:tw-text-6xl"
            >
              ANYWHERE IN THE WORLD
            </h1>
            <button
              class="tw-float-right tw-bg-blue-800 tw-text-white tw-font-bold tw-py-2 tw-px-8 tw-rounded tw-uppercase"
            >
              Learn More
            </button>
          </div>
        </div></v-carousel-item
      >
      <v-carousel-item>
        <div
          class="slide1 tw-flex  tw-justify-end tw-content-center tw-text-white"
        >
          <div class="tw-my-auto tw-px-4">
            <h1
              class="tw-mt-4 tw-text-right tw-text-3xl tw-font-semibold md:tw-text-4xl"
            >
              CARBON <span class="tw-text-blue-700">REDUCTION</span> FOR
              EVERYONE
            </h1>
            <h1
              class="tw-text-right tw-text-2xl tw-font-semibold md:tw-text-6xl"
            >
              ANYWHERE IN THE WORLD
            </h1>
            <button
              class="tw-float-right tw-bg-blue-800 tw-text-white tw-font-bold tw-py-2 tw-px-8 tw-rounded tw-uppercase"
            >
              Learn More
            </button>
          </div>
        </div></v-carousel-item
      >
      <v-carousel-item>
        <div
          class="slide2 tw-flex  tw-justify-end tw-content-center tw-text-white"
        >
          <div class="tw-my-auto tw-px-4">
            <h1
              class="tw-mt-4 tw-text-right tw-text-3xl tw-font-semibold md:tw-text-4xl"
            >
              CARBON <span class="tw-text-blue-700">REDUCTION</span> FOR
              EVERYONE
            </h1>
            <h1
              class="tw-text-right tw-text-2xl tw-font-semibold md:tw-text-6xl"
            >
              ANYWHERE IN THE WORLD
            </h1>
            <button
              class="tw-float-right tw-bg-blue-800 tw-text-white tw-font-bold tw-py-2 tw-px-8 tw-rounded tw-uppercase"
            >
              Learn More
            </button>
          </div>
        </div></v-carousel-item
      >
    </v-carousel>

    <div class="tw-flex tw-flex-wrap">
      <router-link
        to="/auth/register/offsetter"
        class="tw-w-full md:tw-w-1/3 tw-px-2 tw-py-4"
      >
        <div
          class="image-1 tw-h-64 tw-flex tw-justify-center tw-content-center"
        >
          <span
            class="tw-text-white tw-my-auto tw-font-bold tw-text-4xl tw-px-4 tw-text-center"
          >
            JOIN
          </span>
        </div>
      </router-link>

      <router-link
        to="/auth/register/lister"
        class="tw-w-full md:tw-w-1/3 tw-px-2 tw-py-4"
      >
        <div
          class="image-2 tw-h-64 tw-flex tw-justify-center tw-content-center"
        >
          <span
            class="tw-text-white tw-m-auto tw-font-bold tw-text-4xl tw-px-4 tw-text-center"
          >
            REGISTER A PROJECT
          </span>
        </div>
      </router-link>

      <router-link
        to="/auth/register/offsetter"
        class="tw-w-full md:tw-w-1/3 tw-px-2 tw-py-4"
      >
        <div
          class="image-3 tw-h-64 tw-flex tw-justify-center tw-content-center"
        >
          <span
            class="tw-text-white tw-m-auto tw-font-bold tw-text-4xl tw-px-4 tw-text-center"
          >
            OFFSET
          </span>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Shared/Header";

export default {
  components: {
    Header
  },
  data() {
    return {
      items: [
        {
          src: "https://cdn.vuetifyjs.com/images/carousel/squirrel.jpg"
        },
        {
          src: "https://cdn.vuetifyjs.com/images/carousel/sky.jpg"
        },
        {
          src: "https://cdn.vuetifyjs.com/images/carousel/bird.jpg"
        },
        {
          src: "https://cdn.vuetifyjs.com/images/carousel/planet.jpg"
        }
      ]
    };
  }
};
</script>

<style lang="css" scoped>
.slide1 {
  background: linear-gradient(
      89.81deg,
      #111111 0.05%,
      rgba(17, 17, 17, 0.65) 41.25%
    ),
    url("https://res.cloudinary.com/dldd8ucby/image/upload/v1582214315/Eko%20Carbon/alternative-alternative-energy-clouds-eco-energy-433308.jpg");
  background-size: cover;
  min-height: 100vh;
}
.slide2 {
  background: linear-gradient(
      89.81deg,
      #111111 0.05%,
      rgba(17, 17, 17, 0.65) 41.25%
    ),
    url("https://res.cloudinary.com/dldd8ucby/image/upload/v1582206339/Eko%20Carbon/plate-flight-sky-sunset-91217.jpg");
  background-size: cover;
  min-height: 100vh;
}
.slide3 {
  background: linear-gradient(
      89.81deg,
      #111111 0.05%,
      rgba(17, 17, 17, 0.65) 41.25%
    ),
    url("https://res.cloudinary.com/dldd8ucby/image/upload/v1582214322/Eko%20Carbon/architecture-auto-automobiles-bridge-210182.jpg");
  background-size: cover;
  min-height: 100vh;
}

.image-1 {
  background: linear-gradient(
      89.81deg,
      #111111 0.05%,
      rgba(17, 17, 17, 0.65) 41.25%
    ),
    url("https://res.cloudinary.com/dldd8ucby/image/upload/v1582215359/Eko%20Carbon/landscape-sunset-architecture-platform-87236.jpg");
  background-size: cover;
}

.image-2 {
  background: linear-gradient(
      89.81deg,
      #111111 0.05%,
      rgba(17, 17, 17, 0.65) 41.25%
    ),
    url("https://res.cloudinary.com/dldd8ucby/image/upload/v1582215432/Eko%20Carbon/bird-s-eye-view-of-solar-panel-roof-1907419.jpg");
  background-size: cover;
}

.image-3 {
  background: linear-gradient(
      89.81deg,
      #111111 0.05%,
      rgba(17, 17, 17, 0.65) 41.25%
    ),
    url("https://res.cloudinary.com/dldd8ucby/image/upload/v1582215459/Eko%20Carbon/grapes-vineyard-wine-sky-21393.jpg");
  background-size: cover;
}
</style>
